export const LIFELONG_LEARNING_OPERATIONS = [
  "LifelongLearningApplicationDecision",
  "LifelongLearningApplicationInfo",
  "LifelongLearningCpeHours",
  "LifelongLearningCppDetail",
  "LifelongLearningCppProgress",
  "LifelongLearningCurrentEnrollment",
  "LifelongLearningEnrollAction",
  "LifelongLearningMppDetail",
  "LifelongLearningMppProgress",
  "LifelongLearningPrograms",
  "LifelongLearningProgramHistory",
  "LifelongLearningRouteAccess",
  "LifelongLearningSubscriptionBanner",
]
